import { render, staticRenderFns } from "./FilialeManage.vue?vue&type=template&id=763e0b97&scoped=true"
import script from "./FilialeManage.vue?vue&type=script&lang=js"
export * from "./FilialeManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763e0b97",
  null
  
)

export default component.exports